import {
  appLogout,
  createAsyncThunk,
  createSlice,
  injectSlice,
} from '@bonanza-social/toolkit/state';
import { DailyGiftState } from './dailyGift.types';
import { RewardsService } from '@bonanza-social/toolkit/services';

const initialState: DailyGiftState = {
  claimDataState: 'idle',
};

export const claimDailyGift = createAsyncThunk(
  'dailyGift/claim',
  async (rewardId: number) => {
    const response = await RewardsService.claimReward({
      pathParams: { id: rewardId },
    });
    return response;
  },
);

const dailyGift = createSlice({
  name: 'dailyGift',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(claimDailyGift.pending, (state) => {
      state.claimDataState = 'pending';
    });

    builder.addCase(claimDailyGift.fulfilled, (state) => {
      state.claimDataState = 'fulfilled';
    });

    builder.addCase(claimDailyGift.rejected, (state) => {
      state.claimDataState = 'rejected';
    });

    builder.addCase(appLogout, () => {
      return initialState;
    });
  },
});

export const withDailyGift = injectSlice({
  reducerPath: 'dailyGift',
  reducer: dailyGift.reducer,
});

export const selectClaimDailyGiftDataState = withDailyGift.selector(
  (state) => state.dailyGift?.claimDataState,
);

declare global {
  interface LazyLoadedSlices {
    dailyGift: ReturnType<typeof dailyGift.reducer>;
  }
}
